__turbopack_context__.v({
  "tag": "ProductMetaTags-module-scss-module__Aiv5nW__tag",
  "tagRow": "ProductMetaTags-module-scss-module__Aiv5nW__tagRow",
});
